import * as yup from "yup";
const FileSize = 15000000;
const allowedFormats = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const masterResourceTableData = [
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
];


export const IncidentResourceConfig = [
    {
        id: 0,
        name: "",
        heading: "",
        fields: [
            {
                name: "incidentname",
                label: "incidentresourceformlabels.incidentname",
                mandatory: "true",
                type: "input",
            },
            {
                name: "incidentcategory",
                label: "incidentresourceformlabels.incidentcategory",
                type: "select",
                options: [],
                mandatory: "true",
            },
            {
                name: "incidentdatetime",
                label: "incidentresourceformlabels.incidentdatetime",
                type: "datetime",
                maxDate: new Date().toISOString().slice(0, 16)
            },
            {
                name: "selectregion",
                label: "incidentresourceformlabels.selectregion",
                type: "button",

                //type: "input",

            },
            {
                name: "userlist",
                label: "incidentresourceformlabels.userlist",
                type: "multi_select1",
                options: [],


            },

            {
                name: "incidentDes",
                label: "incidentresourceformlabels.incidentDes",
                type: "text_area",
                width: '50%'
            },
        ],
    },
];

export const incidentresourceschema = [
    yup.object({
        incidentname: yup.string().required("Please Enter Incident Name"),
        incidentcategory: yup.string().required("Please select Incident Category"),
        incidentdatetime: yup
            .string()
            .test(
                'is-not-future',
                'Incident date/time cannot be in the future',
                (value) => {
                    if (!value) return false;
                    const selectedDate = new Date(value);
                    const now = new Date();
                    return selectedDate <= now; // Only allow past/current time
                }
            ),
        incidentDes: yup
            .string()
            .max(250, 'Event description must be at most 250 characters')

    }),
];

export const masterResourcecolumnsForExport = [
    { label: "Activity", key: "activity" },
    { label: "Category", key: "category" },
    { label: "Name", key: "name" },
    { label: "Created On", key: "created_on" },
    { label: "Updated On", key: "updated_on" },
    // {label: "Image", key: "resource_image_name"},
    { label: "Unit", key: "unit" },
];
